import * as React from "react";
import axios from "axios";
import { baseURL } from "../API";
import { useSelector } from "react-redux";
import { useState, useEffect } from 'react';

// Custom hooks

const useRentals = () => {
	const token = useSelector((state) => state.token);
	const landlordId = useSelector((state) => state.user.landlord_id);

	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [rentals, setRentals] = React.useState([]);
	const [isLoadingRentals, setLoadingRentals] = React.useState(true);
	const [error, setError] = React.useState(false);
	const [newData, setNewData] = React.useState(true);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/landlords/rentals`);
				setRentals(response.data.data);
				setLoadingRentals(false);
				setNewData(false);
			} catch (e) {
				setError(true);
				setLoadingRentals(false);
			}
		};
		fetchData();
	}, [landlordId, token, newData]);

	return { rentals, isLoadingRentals, error, setNewData };
};

const useRentalUnits = (activeRental) => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [rentalUnits, setRentalUnits] = React.useState("");
	const [isLoadingRentalUnits, setLoadingRentalUnits] = React.useState(true);
	const [error, setError] = React.useState(false);
	const [newData, setNewData] = React.useState(true);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/landlords/rentals/units?rental_id=${activeRental}`);
				setRentalUnits(response.data.data);
				setLoadingRentalUnits(false);
				setNewData(false);
			} catch (e) {
				setError(true);
				setLoadingRentalUnits(false);
			}
		};
		fetchData();
	}, [activeRental, token, newData]);

	return { rentalUnits, isLoadingRentalUnits, error, setNewData };
};


const useUnassignedRentalUnits = (activeUnassignedRental) => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [unassignedRentalUnits, setUnassignedRentalUnits] = React.useState("");
	const [isLoadingUnassignedRentalUnits, setLoadingUnassignedRentalUnits] = React.useState(true);
	const [error, setError] = React.useState(false);
	const [newData , setNewData] = React.useState(true);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/landlords/rentals/units/unoccupied?rental_id=${activeUnassignedRental}`);
				setUnassignedRentalUnits(response.data.data);
				setLoadingUnassignedRentalUnits(false);
				setNewData(false);
			} catch (e) {
				setError(true);
				setLoadingUnassignedRentalUnits(false);
			}
		};
		fetchData();
	}, [activeUnassignedRental, token, newData]);

	return { unassignedRentalUnits, isLoadingUnassignedRentalUnits, error, setNewData  };
};

const useHandleRentalFormSubmit = async (rentalName, rentalType, rentalLocation) => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const landlordId = useSelector((state) => state.user.id);

	try {
		await axios.post(`${baseURL}/landlords/rentals`, {
			related_landlord: landlordId,
			rental_name: rentalName,
			rental_type: rentalType,
			location: rentalLocation,
		});
		// Handle success
	} catch (err) {
		console.error(err);
		// Handle error
	}
};

const useGetRentalSchedules = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [rentalSchedules, setRentalSchedules] = React.useState([]);
	const [isLoadingRentalSchedules, setLoadingRentalSchedules] = React.useState(true);
	const [errorLoadingRentalSchedules, setErrorLoadingRentalSchedules] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/tenants/schedules/admin`);
				setRentalSchedules(response.data.data);
				setLoadingRentalSchedules(false);
			} catch (e) {
				setErrorLoadingRentalSchedules(true);
				setLoadingRentalSchedules(false);
			}
		};
		fetchData();
	}, [token]);

	return { rentalSchedules, isLoadingRentalSchedules, errorLoadingRentalSchedules };
};

const useGetRentalTenants = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [rentalTenants, setRentalTenants] = React.useState([]);
	const [isLoadingRentalTenants, setLoadingRentalTenants] = React.useState(true);
	const [errorLoadingRentalTenants, setErrorLoadingRentalTenants] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/accounts/tenants`);
				setRentalTenants(response.data.data);
				setLoadingRentalTenants(false);
			} catch (e) {
				setErrorLoadingRentalTenants(true);
				setLoadingRentalTenants(false);
			}
		};
		fetchData();
	}, [token]);

	return { rentalTenants, isLoadingRentalTenants, errorLoadingRentalTenants };
};

const useGetTenantsByRentalProperty = (rental_id) => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [tenantsByProperty, setTenantsByProperty] = React.useState([]);
	const [isLoadingTenantsByProperty, setLoadingTenantsByProperty] = React.useState(true);
	const [errorLoadingTenantsByProperty, setErrorLoadingTenantsByProperty] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/landlords/rentals/tenants?rental_id=${rental_id}`);
				setTenantsByProperty(response.data.data);
				setLoadingTenantsByProperty(false);
			} catch (e) {
				setErrorLoadingTenantsByProperty(true);
				setLoadingTenantsByProperty(false);
			}
		};
		fetchData();
	}, [token]);

	return { tenantsByProperty, isLoadingTenantsByProperty, errorLoadingTenantsByProperty };
};


const useGetPastTenantsByRentalProperty = (rental_id) => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [tenantsByProperty, setTenantsByProperty] = React.useState([]);
	const [isLoadingTenantsByProperty, setLoadingTenantsByProperty] = React.useState(true);
	const [errorLoadingTenantsByProperty, setErrorLoadingTenantsByProperty] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/landlords/rentals/tenants?rental_id=${rental_id}&occupancy_status=False`);
				setTenantsByProperty(response.data.data);
				setLoadingTenantsByProperty(false);
			} catch (e) {
				setErrorLoadingTenantsByProperty(true);
				setLoadingTenantsByProperty(false);
			}
		};
		fetchData();
	}, [token]);

	return { tenantsByProperty, isLoadingTenantsByProperty, errorLoadingTenantsByProperty };
};

const useGetDashboardData = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const landlordId = useSelector((state) => state.user.id);
	const [dashboardData, setDashboardData] = React.useState({});
	const [isLoadingDashboardData, setLoadingDashboardData] = React.useState(true);
	const [errorLoadingDashboardData, setErrorLoadingDashboardData] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/landlords/admin/dashboard`);
				setDashboardData(response.data.data);
				setLoadingDashboardData(false);
			} catch (e) {
				setErrorLoadingDashboardData(true);
				setLoadingDashboardData(false);
			}
		};
		fetchData();
	}, [landlordId, token]);

	return { dashboardData, isLoadingDashboardData, errorLoadingDashboardData };
};

const useGetDailySummary = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [dailySummary, setDailySummary] = React.useState(null);
	const [isLoadingDailySummary, setLoadingDailySummary] = React.useState(true);
	const [errorDailySummary, setErrorDailySummary] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/landlords/dashboard/daily_summary`);
				setDailySummary(response.data.data);
				setLoadingDailySummary(false);
			} catch (e) {
				setErrorDailySummary(true);
				setLoadingDailySummary(false);
			}
		};
		fetchData();
	}, [token]);

	return { dailySummary, isLoadingDailySummary, errorDailySummary };
};

const useGetPaymentsData = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const landlordId = useSelector((state) => state.user.id);
	const [paymentsData, setPaymentsData] = React.useState([]);
	const [isLoadingPaymentsData, setLoadingPaymentsData] = React.useState(true);
	const [errorLoadingPaymentsData, setErrorLoadingPaymentsData] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/tenants/payments/admin`);
				setPaymentsData(response.data.data);
				setLoadingPaymentsData(false);
			} catch (e) {
				setErrorLoadingPaymentsData(true);
				setLoadingPaymentsData(false);
			}
		};
		fetchData();
	}, [landlordId, token]);

	return { paymentsData, isLoadingPaymentsData, errorLoadingPaymentsData };
};

const useLandlords = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [landlords, setLandlords] = React.useState([]);
	const [isLoadingLandlords, setLoadingLandlords] = React.useState(true);
	const [error, setError] = React.useState(false);
	const [newItemData, setNewItemData] = useState(true);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/admin/landlords`);
				setLandlords(response.data.data);
				setLoadingLandlords(false);
				setNewItemData(false)
			} catch (e) {
				setError(true);
				setLoadingLandlords(false);
			}
		};
		fetchData();
	}, [token, newItemData]);

	return { landlords, isLoadingLandlords, error, setNewItemData };
};

const useInvisibleLandlords = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [invisibleLandlords, setInvisibleLandlords] = React.useState([]);
	const [isLoadingInvisibleLandlords, setLoadingInvisibleLandlords] = React.useState(true);
	const [errorInvisibleLandlords, setErrorInvisibleLandlords] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/admin/landlords?visibility=False`);
				setInvisibleLandlords(response.data.data);
				setLoadingInvisibleLandlords(false);
			} catch (e) {
				setErrorInvisibleLandlords(true);
				setLoadingInvisibleLandlords(false);
			}
		};
		fetchData();
	}, [token]);

	return { invisibleLandlords, isLoadingInvisibleLandlords, errorInvisibleLandlords };
};

const useBrokers = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [brokers, setBrokers] = React.useState([]);
	const [isLoadingBrokers, setLoadingBrokers] = React.useState(true);
	const [error, setError] = React.useState(false);

	const fetchBrokers = async () => {
		try {
			const response = await axios.get(`${baseURL}/landlords/admin/brokers`);
			setBrokers(response.data.data);
			setLoadingBrokers(false);
		} catch (e) {
			console.error("Error fetching brokers:", e);
			setError(true);
			setLoadingBrokers(false);
		}
	};

	React.useEffect(() => {
		fetchBrokers();
	}, [token]);

	return { brokers, isLoadingBrokers, error, refetch: fetchBrokers };
};


const useAttachLandlord = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const attachLandlord = async (brokerId, landlordId) => {
		setLoading(true);
		try {
			const response = await axios.post(
				`${baseURL}/landlords/admin/brokers/landlords`,
				{
					related_broker: brokerId,
					related_landlord: landlordId,
				}
			);
			setLoading(false);
			return response.data;
		} catch (error) {
			setLoading(false);
			setError(error);
			throw error;
		}
	};

	return { attachLandlord, loading, error };
};



const useBrokerLandlords = (brokerId) => {
	const [brokerLandlords, setBrokerLandlords] = useState([]);
	const [loadingBrokerLandlords, setLoadingBrokerLandlords] = useState(true);
	const [errorBrokerLandlords, setErrorBrokerLandlords] = useState(null);
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

	useEffect(() => {
		const fetchLandlords = async () => {
			try {
				const response = await axios.get(
					`${baseURL}/landlords/admin/brokers/landlords?broker_id=${brokerId}`,
				);
				setBrokerLandlords(response.data.data);
				setLoadingBrokerLandlords(false)
			} catch (error) {
				setErrorBrokerLandlords(error);
				setLoadingBrokerLandlords(false)
			} finally {
				setLoadingBrokerLandlords(false);
			}
		};

		fetchLandlords();
	}, [brokerId]);

	return { brokerLandlords, loadingBrokerLandlords, errorBrokerLandlords };
};

const useTenants = (landlordId) => {
	const [tenants, setTenants] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

	useEffect(() => {
		const fetchTenants = async () => {
			try {
				const response = await axios.get(`${baseURL}/landlords/rentals/tenants?landlord_id=${landlordId}`);
				setTenants(response.data.data);
			} catch (err) {
				setError(err);
			} finally {
				setLoading(false);
			}
		};

		fetchTenants();
	}, []);

	return { tenants, loading, error };
};


const useLandlordProperties = (landlordId, includeInactive = false) => {
	const [landlordProperties, setLandlordProperties] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [newData, setNewData] = useState(true);
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

	useEffect(() => {
		if (!landlordId) {
			setLandlordProperties([]);
			setLoading(false);
			return;
		}
		const fetchLandlordProperties = async () => {
			try {
				const url = `${baseURL}/landlords/rentals?landlord_id=${landlordId}&include_inactive=${includeInactive}`;
				const response = await axios.get(url);
				setLandlordProperties(response.data.data || []);
				setNewData(false);
			} catch (err) {
				setError(err);
			} finally {
				setLoading(false);
			}
		};
		fetchLandlordProperties();
	}, [newData, includeInactive, landlordId]);

	return { landlordProperties, loading, error, setNewData };
};

export const useUsers = () => {
	const [users, setUsers] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

	useEffect(() => {
		const fetchUsers = async () => {
			try {
				const response = await axios.get(`${baseURL}/accounts/users/tenant_users?user_filter=0`);

				setUsers(response.data.data);
			} catch (err) {
				setError(err);
			} finally {
				setLoading(false);
			}
		};

		fetchUsers();
	}, []);

	return { users, loading, error };
};
const useManagers = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [managers, setManagers] = useState([]);
	const [isLoadingManager, setLoadingManager] = useState(true);
	const [error, setError] = useState(false);

	const fetchManager = async () => {
		try {
			const response = await axios.get(`${baseURL}/admin/managers`);
			setManagers(response.data.data);
			setLoadingManager(false);
		} catch (e) {
			console.error("Error fetching managers:", e);
			setError(true);
			setLoadingManager(false);
		}
	};

	React.useEffect(() => {
		fetchManager();
	}, [token]);

	return { managers, isLoadingManager, error, refetch: fetchManager };
};
const useAttachedProperty = (managerId) => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [attachedProperties, setAttachedProperty] = useState([]);
	const [isLoadingAttachedProperties, setLoadingAttachedProperties] = useState(true);
	const [errorAttachedProperties, setError] = useState(false);

	const fetchAttachedProperty = async () => {
		try {
			const response = await axios.get(`${baseURL}/admin/managers/properties?manager_id=${managerId}`);
			setAttachedProperty(response.data.data);
			setLoadingAttachedProperties(false);
		} catch (e) {
			console.error("Error fetching managers:", e);
			setError(true);
			setLoadingAttachedProperties(false);
		}
	};

	React.useEffect(() => {
		fetchAttachedProperty();
	}, []);

	return { attachedProperties, isLoadingAttachedProperties, errorAttachedProperties, refetch: fetchAttachedProperty };
};
const useUnAssignedProperties = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

	const [unAssignedProperties, setUnAssignedProperties] = useState([]);
	const [isLoadingUnAssignedProperties, setLoadingUnAssignedProperties] = useState(true);
	const [errorUnAssignedProperties, setError] = useState(false);

	const fetchUnAssignedProperty = async () => {
		try {
			const response = await axios.get(`${baseURL}/admin/unassigned_properties`);
			setUnAssignedProperties(response.data.data);
			setLoadingUnAssignedProperties(false);
		} catch (e) {
			console.error("Error fetching unassigned properties:", e);
			setError(true);
			setLoadingUnAssignedProperties(false);
		}
	};

	useEffect(() => {
		fetchUnAssignedProperty();
	}, []);

	return { unAssignedProperties, isLoadingUnAssignedProperties, errorUnAssignedProperties, refetch: fetchUnAssignedProperty };
};


const useExpenseTypes = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [expenseTypes, setExpenseTypes] = React.useState([]);
	const [isLoadingExpenseTypes, setLoadingExpenseTypes] = React.useState(true);
	const [errorExpenseTypes, setError] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/admin/expense_types`);
				setExpenseTypes(response.data.data);
				setLoadingExpenseTypes(false);
			} catch (e) {
				setError(true);
				setLoadingExpenseTypes(false);
			}
		};
		fetchData();
	}, []);

	return { expenseTypes, isLoadingExpenseTypes, errorExpenseTypes };
};

const usePaymentMethods = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [paymentMethods, setPaymentMethods] = React.useState([]);
	const [isLoadingPaymentMethods, setLoadingPaymentMethods] = React.useState(true);
	const [errorPaymentMethods, setError] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/tenants/payments/methods`);
				setPaymentMethods(response.data.data);
				setLoadingPaymentMethods(false);
			} catch (e) {
				setError(true);
				setLoadingPaymentMethods(false);
			}
		};
		fetchData();
	}, [token]);

	return { paymentMethods, isLoadingPaymentMethods, errorPaymentMethods };
};

const useLandlordExpenses = (landlord_id) => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [landlordExpenses, setLandlordExpenses] = React.useState({expenses:[], total:0});
	const [isLoadingLandlordExpenses, setLoadingLandlordExpenses] = React.useState(true);
	const [errorLandlordExpenses, setError] = React.useState(false);
	const [newData, setNewData] = React.useState(true);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/admin/landlord_expenses?landlord_id=${landlord_id}`);
				setLandlordExpenses(response.data.data);
				setLoadingLandlordExpenses(false);
				setNewData(false);
			} catch (e) {
				setError(true);
				setLoadingLandlordExpenses(false);
			}
		};
		fetchData();
	}, [token, newData]);

	return { landlordExpenses, isLoadingLandlordExpenses, errorLandlordExpenses, setNewData };
};

const useBrokerPayments = (brokerId) => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [brokerPayments, setBrokerPayments] = React.useState([]);
	const [isLoadingBrokerPayments, setLoadingBrokerPayments] = React.useState(true);
	const [errorBrokerPayments, setError] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/admin/broker_payments?broker_id=${brokerId}`);
				setBrokerPayments(response.data.data);
				setLoadingBrokerPayments(false);
			} catch (e) {
				setError(true);
				setLoadingBrokerPayments(false);
			}
		};
		fetchData();
	}, []);

	return { brokerPayments, isLoadingBrokerPayments, errorBrokerPayments };
};
const useMonthsAndYears = (brokerId) => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [monthsAndYears, setMonthsAndYears] = React.useState([]);
	const [isLoadingMonthsAndYears, setLoadingMonthsAndYears] = React.useState(true);
	const [errorMonthsAndYears, setErrorMonthsAndYears] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/admin/months`);
				setMonthsAndYears(response.data.data);
				setLoadingMonthsAndYears(false);
			} catch (e) {
				setErrorMonthsAndYears(true);
				setLoadingMonthsAndYears(false);
			}
		};
		fetchData();
	}, []);

	return { monthsAndYears, isLoadingMonthsAndYears, errorMonthsAndYears };
};

const useLandlordPayments = (landlordId, year, month) => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [landlordPayments, setLandlordPayments] = React.useState([]);
	const [isLoadingLandlordPayments, setLoadingLandlordPayments] = React.useState(true);
	const [errorLandlordPayments, setError] = React.useState(false);
	const [newItemData, setNewItemData] = useState(true);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				// Construct the base URL
				let url = `${baseURL}/admin/landlord_payments?landlord_id=${landlordId}`;

				// Append year and month only if they are not "All Years" or "All Months"
				if (year !== "All Years" && month !== "All Months") {
					url += `&year=${year}&month=${month}`;
				}

				const response = await axios.get(url);
				setLandlordPayments(response.data.data);
				setLoadingLandlordPayments(false);
				setNewItemData(false);
			} catch (e) {
				setError(true);
				setLoadingLandlordPayments(false);
			}
		};
		fetchData();
	}, [landlordId, year, month, newItemData]);

	return { landlordPayments, isLoadingLandlordPayments, errorLandlordPayments, setNewItemData };
};

const useTenantPayments = (occupancyId) => {
	const token = useSelector((state) => state.token);
	const refreshCount = useSelector((state) => state.refreshCount);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [tenantPayments, setTenantPayments] = React.useState([]);
	const [isLoadingTenantPayments, setLoadingTenantPayments] = React.useState(true);
	const [errorTenantPayments, setErrorTenantPayments] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/tenants/payments/active_periods?occupancy_id=${occupancyId}`);
				setTenantPayments(response.data.data);
				setLoadingTenantPayments(false);
			} catch (e) {
				setErrorTenantPayments(true);
				setLoadingTenantPayments(false);
			}
		};
		fetchData();
	}, [refreshCount, occupancyId]);

	return { tenantPayments, isLoadingTenantPayments, errorTenantPayments };
};

const useGetTenantOccupancyActivePeriodsData = occupancyId => {
	const token = useSelector((state) => state.token)
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [activePeriods, setActivePeriods] = React.useState([]);
	const refreshCount = useSelector((state) => state.refreshCount);
	const [isLoadingActivePeriods, setLoadingActivePeriods] = React.useState(true);
	const [errorLoadingActivePeriods, setErrorLoadingActivePeriods] = React.useState(false);
	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/tenants/completed_payments?occupancy_id=${occupancyId}`);
				setActivePeriods(response.data.data);
				setLoadingActivePeriods(false);
			} catch (e) {
				setErrorLoadingActivePeriods(true);
				setLoadingActivePeriods(false);
			}
		};
		fetchData();
	}, [occupancyId, refreshCount]);
	return { activePeriods, isLoadingActivePeriods, errorLoadingActivePeriods };
};


const useGetPaymentsByActivePeriodData = (period_id) => {
	const token = useSelector((state) => state.token)
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [paymentsByActivePeriodData, setPaymentsByActivePeriodData] = React.useState([]);
	const [isLoadingPaymentsByActivePeriodData, setLoadingPaymentsByActivePeriodData] = React.useState(true);
	const [errorLoadingPaymentsByActivePeriodData, setErrorLoadingPaymentsByActivePeriodData] = React.useState(false);
	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/tenants/completed_payments/payments_list?period_id=${period_id}`);
				setPaymentsByActivePeriodData(response.data.data);
				setLoadingPaymentsByActivePeriodData(false);
			} catch (e) {
				setErrorLoadingPaymentsByActivePeriodData(true);
				setLoadingPaymentsByActivePeriodData(false);
			}
		};
		fetchData();
	}, [period_id]);
	return { paymentsByActivePeriodData, isLoadingPaymentsByActivePeriodData, errorLoadingPaymentsByActivePeriodData };
};

const useReferredLandlords = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [referredLandlords, setReferredLandlords] = React.useState([]);
	const [isLoadingReferredLandlords, setLoadingReferredLandlords] = React.useState(true);
	const [errorReferredLandlords, setError] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/admin/referrals/landlord/list`);
				setReferredLandlords(response.data.data);
			} catch (e) {
				setError(true);
				setLoadingReferredLandlords(false);
			}
		};
		fetchData();
	}, []);

	return { referredLandlords, isLoadingReferredLandlords, errorReferredLandlords };
};


const useOnboardingLandlords = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [onboardingLandlords, setOnboardingLandlords] = React.useState([]);
	const [isLoadingOnboardingLandlords, setLoadingOnboardingLandlords] = React.useState(true);
	const [errorOnboardingLandlords, setError] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/admin/landlords/self_registered`);
				setOnboardingLandlords(response.data.data);
			} catch (e) {
				setError(true);
				setLoadingOnboardingLandlords(false);
			}
		};
		fetchData();
	}, []);

	return { onboardingLandlords, isLoadingOnboardingLandlords, errorOnboardingLandlords };
};

const useRegisteredProperties = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [registeredProperties, setRegisteredProperties] = React.useState([]);
	const [isLoadingRegisteredProperties, setLoadingRegisteredProperties] = React.useState(true);
	const [errorRegisteredProperties, setError] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/admin/landlord_registration/list`);
				setRegisteredProperties(response.data.data);
			} catch (e) {
				setError(true);
				setLoadingRegisteredProperties(false);
			}
		};
		fetchData();
	}, []);

	return { registeredProperties, isLoadingRegisteredProperties, errorRegisteredProperties };
};

const useGetRentalTicketsByProperty = () => {
	const token = useSelector((state) => state.token)
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const rentalId = useSelector((state) => state.property_id)
	const [rentalTicketsByProperty, setRentalTicketsByProperty] = React.useState([]);
	const [isLoadingRentalTicketsByProperty, setLoadingRentalTicketsByProperty] = React.useState(true);
	const [errorLoadingRentalTicketsByProperty, setErrorLoadingRentalTicketsByProperty] = React.useState(false);
	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/landlords/rentals/units/tickets?rental_id=${rentalId}`);
				setRentalTicketsByProperty(response.data.data);
				setLoadingRentalTicketsByProperty(false);
			} catch (e) {
				setErrorLoadingRentalTicketsByProperty(true);
				setLoadingRentalTicketsByProperty(false);
			}
		};
		fetchData();
	}, [rentalId]);
	return { rentalTicketsByProperty, isLoadingRentalTicketsByProperty, errorLoadingRentalTicketsByProperty };
};

const usePeriodErrorLogs = () =>{
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [periodErrorLogs, setPeriodErrorLogs] = React.useState([]);
	const [isLoadingPeriodErrorLogs, setLoadingPeriodErrorLogs] = React.useState(true);
	const [errorPeriodErrorLogs, setError] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/analytics/logs/periods`);
				setPeriodErrorLogs(response.data.data);
				setLoadingPeriodErrorLogs(false);
			} catch (e) {
				setError(true);
				setLoadingPeriodErrorLogs(false);
			}
		};
		fetchData();
	}, []);

	return { periodErrorLogs, isLoadingPeriodErrorLogs, errorPeriodErrorLogs };
}


const usePaymentErrorLogs = () =>{
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [paymentErrorLogs, setPaymentErrorLogs] = React.useState([]);
	const [isLoadingPaymentErrorLogs, setLoadingPaymentErrorLogs] = React.useState(true);
	const [errorPaymentErrorLogs, setError] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/analytics/logs/payments`);
				setPaymentErrorLogs(response.data.data);
				setLoadingPaymentErrorLogs(false);
			} catch (e) {
				setError(true);
				setLoadingPaymentErrorLogs(false);
			}
		};
		fetchData();
	}, []);

	return { paymentErrorLogs, isLoadingPaymentErrorLogs, errorPaymentErrorLogs };
}

const usePropertyDashboardStatistics = (property, month, year) =>{
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [propertyDashboardStatistics, setPropertyDashboardStatistics] = React.useState({"collection_rate": {"paid": 0,"unpaid": 0},"occupancy_rate": {"occupied": 0,"unoccupied": 0}});
	const [isLoadingPropertyDashboardStatistics, setLoadingPropertyDashboardStatistics] = React.useState(true);
	const [errorPropertyDashboardStatistics, setError] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(
					`${baseURL}/landlords/properties/statistics?rental_id=${property}&month=${month}&year=${year}`
				);
				setPropertyDashboardStatistics(response.data.data);
				setLoadingPropertyDashboardStatistics(false);
			} catch (e) {
				setError(true);
				setLoadingPropertyDashboardStatistics(false);
			}
		};
		fetchData();
	}, [property, month, year]);

	return { propertyDashboardStatistics, isLoadingPropertyDashboardStatistics, errorPropertyDashboardStatistics };
}

const usePropertyDashboardRevenue = (property, month, year) =>{
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [propertyDashboardRevenue, setPropertyDashboardRevenue] = React.useState({
        "balances": {"total_balance": 0,"total_income": 0,"total_expense": 0},
        "months": [
            {"month": "January","alias": "Jan","income": 0,"expense": 0},{"month": "February","alias": "Feb","income": 0,"expense": 0},{"month": "March","alias": "Mar","income": 0,"expense": 0},{"month": "April","alias": "Apr","income": 0,"expense": 0},{"month": "May","alias": "May","income": 0,"expense": 0},{"month": "June","alias": "Jun","income": 0,"expense": 0},{"month": "July","alias": "Jul","income": 0,"expense": 0},{"month": "August","alias": "Aug","income": 0,"expense": 0},{"month": "September","alias": "Sep","income": 0,"expense": 0},{"month": "October","alias": "Oct","income": 0,"expense": 50000},{"month": "November","alias": "Nov","income": 0,"expense": 0},{"month": "December","alias": "Dec","income": 0,"expense": 0}
        ]
    });
	const [isLoadingPropertyDashboardRevenue, setLoadingPropertyDashboardRevenue] = React.useState(true);
	const [errorPropertyDashboardRevenue, setError] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/landlords/properties/revenue_overview?rental_id=${property}&month=${month}&year=${year}`);
				setPropertyDashboardRevenue(response.data.data);
				setLoadingPropertyDashboardRevenue(false);
			} catch (e) {
				setError(true);
				setLoadingPropertyDashboardRevenue(false);
			}
		};
		fetchData();
	}, [property, month, year]);

	return { propertyDashboardRevenue, isLoadingPropertyDashboardRevenue, errorPropertyDashboardRevenue };
}

const usePropertyDashboardRevenueMonths = (property, month, year) =>{
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [propertyDashboardRevenueMonths, setPropertyDashboardRevenueMonths] = React.useState({
        "balances": {"total_balance": 0,"total_income": 0,"total_expense": 0},
        "months": [
            {"month": "January","alias": "Jan","income": 0,"expense": 0},{"month": "February","alias": "Feb","income": 0,"expense": 0},{"month": "March","alias": "Mar","income": 0,"expense": 0},{"month": "April","alias": "Apr","income": 0,"expense": 0},{"month": "May","alias": "May","income": 0,"expense": 0},{"month": "June","alias": "Jun","income": 0,"expense": 0},{"month": "July","alias": "Jul","income": 0,"expense": 0},{"month": "August","alias": "Aug","income": 0,"expense": 0},{"month": "September","alias": "Sep","income": 0,"expense": 0},{"month": "October","alias": "Oct","income": 0,"expense": 50000},{"month": "November","alias": "Nov","income": 0,"expense": 0},{"month": "December","alias": "Dec","income": 0,"expense": 0}
        ]
    });
	const [isLoadingPropertyDashboardRevenueMonths, setLoadingPropertyDashboardRevenueMonths] = React.useState(true);
	const [errorPropertyDashboardRevenueMonths, setError] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/landlords/properties/monthly_income?rental_id=${property}&month=${month}&year=${year}`);
				setPropertyDashboardRevenueMonths(response.data.data);
				setLoadingPropertyDashboardRevenueMonths(false);
			} catch (e) {
				setError(true);
				setLoadingPropertyDashboardRevenueMonths(false);
			}
		};
		fetchData();
	}, [property, month, year]);

	return { propertyDashboardRevenueMonths, isLoadingPropertyDashboardRevenueMonths, errorPropertyDashboardRevenueMonths };
}


const usePropertyDashboardCards = (property, month, year) =>{
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [propertyDashboardCards, setPropertyDashboardCards] = React.useState({
        "cards": {
            "total_units": {
                "number": 0
            },
            "open_tickets": {
                "number": 0
            },
            "current_tenants": {
                "number": 0,
                "units": 0
            },
            "rent_arrears": {
                "amount": 0,
                "units": 0,
                "as_of": "December"
            },
            "rent_collected": {
                "amount": 0,
                "units": 0,
                "total": 0
            }
        }
    });
	const [isLoadingPropertyDashboardCards, setLoadingPropertyDashboardCards] = React.useState(true);
	const [errorPropertyDashboardCards, setError] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/landlords/properties/dashboard_cards?rental_id=${property}&month=${month}&year=${year}`);
				setPropertyDashboardCards(response.data.data);
				setLoadingPropertyDashboardCards(false);
			} catch (e) {
				setError(true);
				setLoadingPropertyDashboardCards(false);
			}
		};
		fetchData();
	}, [property, month, year]);

	return { propertyDashboardCards, isLoadingPropertyDashboardCards, errorPropertyDashboardCards };
}

const useCompletedSchedules = (search = "", isCompleted = true, isActive = true, page = 1, pageSize = 10) => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [completedSchedules, setCompletedSchedules] = useState([]);
	const [totalCount, setTotalCount] = useState(0);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState(false);
	const [newData, setNewData] = useState(true);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(
					`${baseURL}/tenants/completed-schedules?search=${search}&page=${page}&page_size=${pageSize}`
				);
				setCompletedSchedules(response.data.data.results);
				setTotalCount(response.data.data.count);
				setIsLoading(false);
				setNewData(false);
			} catch (e) {
				setError(true);
				setIsLoading(false);
			}
		};
		fetchData();
	}, [token, search, isCompleted, isActive, newData, page, pageSize]);

	const updateOutstandingBalance = async (id, outstandingBalance) => {
		try {
			await axios.patch(`${baseURL}/tenants/completed-schedules`, {
				id,
				outstanding_balance: outstandingBalance
			});
			setNewData(true);
			return true;
		} catch (error) {
			setError(true);
			return false;
		}
	};

	return { completedSchedules, totalCount, isLoading, error, setNewData, updateOutstandingBalance };
};

const useGetPropertyArrears = (propertyId, date) => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [arrearsData, setArrearsData] = React.useState({
		arrears_records: [],
		summary: {
			total_amount_in_arrears: 0,
			tenants_in_arrears: 0,
			total_records: 0
		}
	});
	const [isLoadingArrearsData, setLoadingArrearsData] = React.useState(true);
	const [errorArrearsData, setError] = React.useState(false);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(
					`${baseURL}/landlords/properties/arrears_by_date?rental_id=${propertyId}&date=${date}`
				);
				setArrearsData(response.data.data);
				setLoadingArrearsData(false);
			} catch (e) {
				setError(true);
				setLoadingArrearsData(false);
			}
		};
		
		if (propertyId && date) {
			fetchData();
		}
	}, [propertyId, date]);

	return { arrearsData, isLoadingArrearsData, errorArrearsData };
};

const useComprehensiveReports = (filters = {}, options = {}) => {
	const { skipFetch = false } = options;
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [reportData, setReportData] = useState([]);
	const [summary, setSummary] = useState(null);
	const [isLoadingReports, setLoadingReports] = useState(false);
	const [error, setError] = useState(false);

	const fetchReports = async (queryParams = {}) => {
		setLoadingReports(true);
		setError(false);
		try {
			const params = new URLSearchParams();
			if (queryParams.landlord_id) params.append('landlord_id', queryParams.landlord_id);
			if (queryParams.rental_id) params.append('rental_id', queryParams.rental_id);
			if (queryParams.month) params.append('month', queryParams.month);
			if (queryParams.year) params.append('year', queryParams.year);
			if (queryParams.include_unpaid !== undefined) params.append('include_unpaid', queryParams.include_unpaid);

			const response = await axios.get(`${baseURL}/admin/reports/comprehensive?${params.toString()}`);
			const report_data = response.data.data.report_data || [];
			const summary_data = response.data.data.summary || null;
			setReportData(report_data);
			setSummary(summary_data);
			setLoadingReports(false);
			return { reportData: report_data, summary: summary_data };
		} catch (e) {
			console.error("Error fetching comprehensive reports:", e);
			setError(true);
			setLoadingReports(false);
			return null;
		}
	};

	React.useEffect(() => {
		if (!skipFetch) fetchReports(filters);
	}, [filters, token, skipFetch]);

	return { 
		reportData, 
		summary, 
		isLoadingReports, 
		error, 
		refetch: fetchReports 
	};
};

const useLandlordPayoutReports = (filters = {}, options = {}) => {
	const { skipFetch = false } = options;
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [payments, setPayments] = useState([]);
	const [totalLandlordPayments, setTotalLandlordPayments] = useState(0);
	const [count, setCount] = useState(0);
	const [isLoadingPayouts, setLoadingPayouts] = useState(false);
	const [error, setError] = useState(false);

	const fetchPayouts = async (queryParams = {}) => {
		setLoadingPayouts(true);
		setError(false);
		try {
			const params = new URLSearchParams();
			if (queryParams.landlord_id) params.append('landlord_id', queryParams.landlord_id);
			if (queryParams.month) params.append('month', queryParams.month);
			if (queryParams.year) params.append('year', queryParams.year);

			const queryString = params.toString();
			const url = queryString ? `${baseURL}/admin/reports/landlord_payouts?${queryString}` : `${baseURL}/admin/reports/landlord_payouts`;
			const response = await axios.get(url);
			const data = response.data?.data || {};
			setPayments(data.payments || []);
			setTotalLandlordPayments(data.total_landlord_payments ?? 0);
			setCount(data.count ?? 0);
			setLoadingPayouts(false);
			return data;
		} catch (e) {
			console.error("Error fetching landlord payout reports:", e);
			setError(true);
			setLoadingPayouts(false);
			return null;
		}
	};

	React.useEffect(() => {
		if (!skipFetch) fetchPayouts(filters);
	}, [filters, token, skipFetch]);

	return {
		payments,
		totalLandlordPayments,
		count,
		isLoadingPayouts,
		error,
		refetch: fetchPayouts,
	};
};

const useExpenseReports = (filters = {}, options = {}) => {
	const { skipFetch = false } = options;
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [expenses, setExpenses] = useState([]);
	const [totalExpenses, setTotalExpenses] = useState(0);
	const [count, setCount] = useState(0);
	const [isLoadingExpenses, setLoadingExpenses] = useState(false);
	const [error, setError] = useState(false);

	const fetchExpenses = async (queryParams = {}) => {
		setLoadingExpenses(true);
		setError(false);
		try {
			const params = new URLSearchParams();
			if (queryParams.landlord_id) params.append('landlord_id', queryParams.landlord_id);
			if (queryParams.month) params.append('month', queryParams.month);
			if (queryParams.year) params.append('year', queryParams.year);

			const queryString = params.toString();
			const url = queryString ? `${baseURL}/admin/reports/expenses?${queryString}` : `${baseURL}/admin/reports/expenses`;
			const response = await axios.get(url);
			const data = response.data?.data || {};
			setExpenses(data.expenses || []);
			setTotalExpenses(data.total_expenses ?? 0);
			setCount(data.count ?? 0);
			setLoadingExpenses(false);
			return data;
		} catch (e) {
			console.error("Error fetching expense reports:", e);
			setError(true);
			setLoadingExpenses(false);
			return null;
		}
	};

	React.useEffect(() => {
		if (!skipFetch) fetchExpenses(filters);
	}, [filters, token, skipFetch]);

	return {
		expenses,
		totalExpenses,
		count,
		isLoadingExpenses,
		error,
		refetch: fetchExpenses,
	};
};

const useSecurityDeposits = (rentalId) => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [deposits, setDeposits] = useState([]);
	const [summary, setSummary] = useState(null);
	const [isLoadingDeposits, setLoadingDeposits] = useState(false);
	const [error, setError] = useState(false);

	const fetchDeposits = async () => {
		if (!rentalId) return;
		
		setLoadingDeposits(true);
		setError(false);
		try {
			const response = await axios.get(`${baseURL}/tenants/security-deposits?rental_id=${rentalId}`);
			setDeposits(response.data.data);
			setSummary(response.data.summary);
			setLoadingDeposits(false);
		} catch (e) {
			console.error("Error fetching security deposits:", e);
			setError(true);
			setLoadingDeposits(false);
		}
	};

	React.useEffect(() => {
		if (rentalId) {
			fetchDeposits();
		}
	}, [rentalId, token]);

	return { 
		deposits, 
		summary, 
		isLoadingDeposits, 
		error, 
		refetch: fetchDeposits 
	};
};

const useSecurityDepositDetails = (depositId) => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [deposit, setDeposit] = useState(null);
	const [isLoadingDetails, setLoadingDetails] = useState(false);
	const [error, setError] = useState(false);

	const fetchDetails = async () => {
		if (!depositId) return;
		
		setLoadingDetails(true);
		setError(false);
		try {
			const response = await axios.get(`${baseURL}/tenants/security-deposits/${depositId}`);
			setDeposit(response.data.data);
			setLoadingDetails(false);
		} catch (e) {
			console.error("Error fetching deposit details:", e);
			setError(true);
			setLoadingDetails(false);
		}
	};

	React.useEffect(() => {
		if (depositId) {
			fetchDetails();
		}
	}, [depositId, token]);

	return { 
		deposit, 
		isLoadingDetails, 
		error, 
		refetch: fetchDetails 
	};
};

const useUpdateSecurityDeposit = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [isUpdating, setUpdating] = useState(false);
	const [error, setError] = useState(false);

	const updateDeposit = async (depositId, updateData) => {
		setUpdating(true);
		setError(false);
		try {
			const response = await axios.patch(`${baseURL}/tenants/security-deposits/${depositId}/update`, updateData);
			setUpdating(false);
			return response.data;
		} catch (e) {
			console.error("Error updating security deposit:", e);
			setError(true);
			setUpdating(false);
			throw e;
		}
	};

	return { 
		updateDeposit, 
		isUpdating, 
		error 
	};
};

const useRentalPayments = (rentalId, year) => {
	const token = useSelector((state) => state.token);
	const propertyId = useSelector((state) => state.property_id);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [rentalPayments, setRentalPayments] = React.useState([]);
	const [isLoadingRentalPayments, setLoadingRentalPayments] = React.useState(true);
	const [errorRentalPayments, setErrorRentalPayments] = React.useState(false);
	const [newData, setNewData] = React.useState(true);

	React.useEffect(() => {
		const fetchData = async () => {
			// Use rental_id from prop, or fallback to property_id from state
			const effectiveRentalId = rentalId || propertyId;
			
			if (!effectiveRentalId) {
				console.log("No rental_id available, skipping fetch. Available sources:", {
					prop: rentalId,
					stateProperty: propertyId
				});
				setLoadingRentalPayments(false);
				return;
			}
			
			try {
				setLoadingRentalPayments(true);
				setErrorRentalPayments(false);
				
				// Build URL with rental_id and optional year parameter
				let url = `${baseURL}/landlords/rentals/units/payments?rental_id=${effectiveRentalId}`;
				if (year) {
					url += `&year=${year}`;
				}
				
				console.log("Fetching rental payments from:", url);
				const response = await axios.get(url);
				console.log("Rental payments response:", response.data);
				setRentalPayments(response.data.data || []);
				setLoadingRentalPayments(false);
				setNewData(false);
			} catch (e) {
				console.error("Error fetching rental payments:", e);
				setErrorRentalPayments(true);
				setLoadingRentalPayments(false);
				setNewData(false);
			}
		};
		
		fetchData();
	}, [rentalId, propertyId, token, newData, year]);

	return { rentalPayments, isLoadingRentalPayments, errorRentalPayments, setNewData };
};

const usePropertyVisitBookings = (filters = {}) => {
	const [bookings, setBookings] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [newData, setNewData] = useState(true);
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

	useEffect(() => {
		const fetchBookings = async () => {
			try {
				setLoading(true);
				setError(null);
				// Build query parameters
				const queryParams = new URLSearchParams();
				
				if (filters.rental_id) {
					queryParams.append('rental_id', filters.rental_id);
				}
				if (filters.unit_id) {
					queryParams.append('unit_id', filters.unit_id);
				}
				if (filters.status) {
					queryParams.append('status', filters.status);
				}
				if (filters.email) {
					queryParams.append('email', filters.email);
				}
				if (filters.phone_number) {
					queryParams.append('phone_number', filters.phone_number);
				}

				const url = `${baseURL}/tenants/houses/visit-booking${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
				const response = await axios.get(url);
				
				if (response.data.status === 200) {
					setBookings(response.data.data || []);
				} else {
					setError(response.data.error || 'Failed to fetch bookings');
				}
				setNewData(false);
			} catch (err) {
				setError(err.response?.data?.error || err.message || 'Failed to fetch bookings');
			} finally {
				setLoading(false);
			}
		};

		fetchBookings();
	}, [newData, filters.rental_id, filters.unit_id, filters.status, filters.email, filters.phone_number, token]);

	const updateBooking = async (bookingId, updateData) => {
		try {
			setError(null);
			const response = await axios.patch(
				`${baseURL}/tenants/houses/visit-booking/${bookingId}`,
				updateData
			);
			
			if (response.data.status === 200) {
				setNewData(true); // Trigger refetch
				return { success: true, data: response.data.data };
			} else {
				throw new Error(response.data.error || 'Failed to update booking');
			}
		} catch (err) {
			const errorMessage = err.response?.data?.error || err.message || 'Failed to update booking';
			setError(errorMessage);
			throw new Error(errorMessage);
		}
	};

	return { bookings, loading, error, setNewData, updateBooking };
};

const useOrganisations = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [organisations, setOrganisations] = React.useState([]);
	const [isLoadingOrganisations, setLoadingOrganisations] = React.useState(true);
	const [error, setError] = React.useState(false);
	const [newData, setNewData] = useState(true);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/admin/organisations`);
				setOrganisations(Array.isArray(response.data?.data) ? response.data.data : []);
				setLoadingOrganisations(false);
				setNewData(false);
			} catch (e) {
				setError(true);
				setLoadingOrganisations(false);
			}
		};
		fetchData();
	}, [token, newData]);

	return { organisations, isLoadingOrganisations, error, setNewData };
};

const useRelationshipManagers = () => {
	const token = useSelector((state) => state.token);
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	const [relationshipManagers, setRelationshipManagers] = React.useState([]);
	const [isLoadingRelationshipManagers, setLoadingRelationshipManagers] = React.useState(true);
	const [error, setError] = React.useState(false);
	const [newData, setNewData] = useState(true);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${baseURL}/admin/relationship_managers`);
				setRelationshipManagers(Array.isArray(response.data?.data) ? response.data.data : []);
				setLoadingRelationshipManagers(false);
				setNewData(false);
			} catch (e) {
				setError(true);
				setLoadingRelationshipManagers(false);
			}
		};
		fetchData();
	}, [token, newData]);

	return { relationshipManagers, isLoadingRelationshipManagers, error, setNewData };
};

// Export hooks
export {
	useRentals, useHandleRentalFormSubmit, useRentalUnits,usePropertyDashboardRevenueMonths, useGetRentalSchedules, useGetRentalTenants, useGetDashboardData, useGetPaymentsData,
	useLandlords, useBrokers, useAttachLandlord, useBrokerLandlords, useTenants, useManagers, useAttachedProperty, useUnAssignedProperties, useGetTenantOccupancyActivePeriodsData,useGetPastTenantsByRentalProperty,
	useLandlordExpenses, useExpenseTypes, usePaymentMethods, useBrokerPayments, useOnboardingLandlords, useMonthsAndYears, useLandlordPayments, useGetTenantsByRentalProperty, useReferredLandlords, useTenantPayments, useRegisteredProperties,
	useLandlordProperties, useUnassignedRentalUnits, useInvisibleLandlords, usePropertyDashboardStatistics, usePropertyDashboardCards, usePropertyDashboardRevenue, useGetRentalTicketsByProperty, useGetPaymentsByActivePeriodData,
	usePeriodErrorLogs, usePaymentErrorLogs, useCompletedSchedules, useGetPropertyArrears, useComprehensiveReports, useLandlordPayoutReports, useExpenseReports, useSecurityDeposits, useSecurityDepositDetails, useUpdateSecurityDeposit, useRentalPayments, useGetDailySummary, usePropertyVisitBookings,
	useOrganisations, useRelationshipManagers
};


